import React from 'react';
import ReactDOM from 'react-dom';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Breed } from '../../../structures/models/breed';
import BreedCard from '../card/breed-card';
import FANextArrow from './components/fa-next-arrow';
import FAPrevArrow from './components/fa-prev-arrow';

interface BreedCardSliderProps {
  breeds: Breed[];
  infinite?: boolean;
}

const BreedCardSlider: React.FC<BreedCardSliderProps> = ({ breeds, infinite = false }) => {
  const settings: Settings = {
    infinite: breeds.length > 5 ? infinite : false,
    slidesToShow: 5,
    slidesToScroll: 5,
    rows: 1,
    speed: 500,
    centerMode: false,
    nextArrow: <FANextArrow />,
    prevArrow: <FAPrevArrow />,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          infinite: breeds.length > 4 ? infinite : false,
          slidesToShow: 4,
          slidesToScroll: 4,
          autoplaySpeed: 8000,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          infinite: breeds.length > 3 ? infinite : false,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplaySpeed: 6000,
        },
      },
      {
        breakpoint: 991,
        settings: {
          infinite: breeds.length > 2 ? infinite : false,
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 767,
        settings: {
          infinite,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 5000,
        },
      },
    ],
  };

  return (
    <>
      <Slider
        {...settings}
      >
        {breeds.map((breed) => {
          return (
            <div key={breed.id}>
              <div className="react-breed-card">
                <BreedCard
                  breed={breed}
                />
              </div>
            </div>
          );
        })}
      </Slider>
    </>
  );
};

export default BreedCardSlider;

if (document.getElementsByClassName('react-breed-card-slider').length > 0) {
  document.querySelectorAll('.react-breed-card-slider').forEach((element) => {
    const breeds = JSON.parse(element.getAttribute('data-breeds') ?? '');
    const infinite = JSON.parse(element.getAttribute('data-infinite') ?? 'false');
    ReactDOM.render(<BreedCardSlider breeds={breeds} infinite={infinite} />, element);
  });
}
